import './RAAccordionRow.scss';

// @ vendors
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// @ components
import { RAAccordionHeader } from '../RAAccordionHeader/RAAccordionHeader';
import { RAAccordionBody } from '../RAAccordionBody/RAAccordionBody';
// @ constants
import { INVESTMENT_EXPERIENCE, INVESTMENT_EXPERIENCE_BUTTONS_ANSWERS } from 'constants/uTagConstants/RAConstants';

export const RAAccordionRow = ({
    expandAccordionRow,
    expandedRowId,
    formActions,
    profileModel,
    row,
    rowIndex,
    selectAccordionButton,
    selectedOption,
    userProfile,
    validateStep,
    recordEvent,
}) => {
    const { title, text, id, icon, buttons } = row;
    const isExpanded = expandedRowId === id;
    const isCompleted = selectedOption !== 'answer1';
    const rowClassName = classNames('ra-accordion-row', {
        'ra-accordion-row--is-expanded': isExpanded,
    });

    useEffect(() => {
        const product = INVESTMENT_EXPERIENCE[id];
        const answer = INVESTMENT_EXPERIENCE_BUTTONS_ANSWERS[selectedOption];
        recordEvent(`${product} - ${answer} - exito`);
    }, [isCompleted]);

    return (
        <div className="ra-accordion-row-wrapper">
            <div className={rowClassName}>
                <RAAccordionHeader
                    expandAccordionRow={expandAccordionRow}
                    icon={icon}
                    id={id}
                    isExpanded={isExpanded}
                    title={title}
                    buttons={buttons}
                    formActions={formActions}
                    profileModel={profileModel}
                    rowId={id}
                    rowIndex={rowIndex}
                    selectedOption={selectedOption}
                    selectAccordionButton={selectAccordionButton}
                    userProfile={userProfile}
                    validateStep={validateStep}
                />
                <RAAccordionBody
                    expandAccordionRow={expandAccordionRow}
                    id={id}
                    title={title}
                    rowIndex={rowIndex}
                    text={text}
                    isExpanded={isExpanded}
                />
            </div>
        </div>
    );
};

RAAccordionRow.propTypes = {
    expandAccordionRow: PropTypes.func.isRequired,
    expandedRowId: PropTypes.string,
    formActions: PropTypes.object.isRequired,
    profileModel: PropTypes.string.isRequired,
    row: PropTypes.object,
    rowIndex: PropTypes.number,
    selectedOption: PropTypes.string.isRequired,
    selectAccordionButton: PropTypes.func.isRequired,
    userProfile: PropTypes.object.isRequired,
    validateStep: PropTypes.func,
    recordEvent: PropTypes.func,
};
